import { LoaderService } from './../../_services/loader.service';
import { Component, OnInit, ChangeDetectorRef, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit, OnDestroy {
  private readonly loader: LoaderService = inject(LoaderService);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  loaderSubscriber: Subscription;
  started: boolean;

  ngOnInit() {
    this.loaderSubscriber = this.loader.loaderStatus$.subscribe(bool => {
      this.started = bool;
      this.cdr.detectChanges();
    });
  }

   ngOnDestroy() {
    if (this.loaderSubscriber !== undefined) {
      this.loaderSubscriber.unsubscribe();
    }
   }

}
